var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7391 8.12578H2.76012L4.817 10.1827C5.40782 10.7735 4.52159 11.6597 3.93077 11.0689L2.0575 9.1927L0.806993 7.94023C0.564632 7.69642 0.564632 7.30267 0.806993 7.05887L3.93077 3.93144C4.04962 3.80932 4.21321 3.74079 4.38365 3.74221C4.94628 3.74228 5.22239 4.42756 4.817 4.8177L2.75523 6.87461H13.7715C14.638 6.9176 14.5733 8.16892 13.7391 8.12578Z",
    fill: "#14489F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.3aa6b82920d5cc5e0eac931a6ab3285c.svg";
export { ForwardRef as ReactComponent };